import React from 'react';
import Option from '../../Option';
import handleOptionClick from './handleOptionClick';
const processChildren = ({ suggestions, name, suggestedValue, setSuggestedValue, setEnteredValue, onSelection, setIsNavigated, setOff }) => {
    const handleClick = handleOptionClick(setEnteredValue, setSuggestedValue, setIsNavigated, setOff, onSelection);
    return suggestions.map((suggestion, i) => (React.createElement(Option, { name: name, key: suggestion, value: suggestion, labelText: suggestion, selectedValue: suggestedValue, onClick: handleClick, dontRegister: true, noTab: true, noBorder: i === 0 })));
};
export default processChildren;
//# sourceMappingURL=processChildren.js.map